var _rect, _rect2, _rect3, _g, _rect4, _g2, _rect5, _g3, _rect6, _g4, _rect7, _rect8, _rect9, _path, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttribute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463.02,
    height: 228.8,
    viewBox: "0 0 122.51 60.537",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.4979 -4.4979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2491 0 0 1.1553 -109.35 1.9102)",
    strokeWidth: 0.27554
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.39,
    y: 2.4878,
    width: 97.582,
    height: 51.902,
    rx: 0.84729,
    ry: 0.91605,
    fill: "#528dff",
    fillOpacity: 0.05,
    stroke: "#0057ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeOpacity: 0.66,
    strokeWidth: 0.49589
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165.89,
    y: 24.332,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#808080",
    fillOpacity: 0.33,
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 24.332,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#0058ff",
    opacity: 0.6,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 23.858,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.264,
    y: 23.55,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.89,
    y: 30.832,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    opacity: 0.8
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 30.832,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#0058ff",
    opacity: 0.8,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 30.358,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.264,
    y: 30.05,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.89,
    y: 37.044,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 37.044,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#0058ff",
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 36.57,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.264,
    y: 36.263,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.89,
    y: 43.141,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    opacity: 0.4
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 43.141,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#0058ff",
    opacity: 0.4,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 42.668,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.264,
    y: 42.36,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.89,
    y: 49.125,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    opacity: 0.9
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 49.125,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#0058ff",
    opacity: 0.9,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 48.651,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    fill: "#808080",
    fillOpacity: 0.33,
    opacity: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 93.264,
    y: 48.343,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    fill: "#808080",
    fillOpacity: 0.33,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0058ff"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.1042 0 0 1.1938 84.885 -3.21)",
    d: "m8.4766 13.552c-0.1759-0.03263-0.31707-0.16038-0.3707-0.33544-0.0178-0.0581-0.02377-0.1437-0.01396-0.20005 0.01689-0.09701 0.16682-0.59151 0.3112-1.0266 0.02303-0.06937 0.0528-0.12015 0.10112-0.17233 0.07496-0.08097 0.11464-0.10156 0.50166-0.26029 0.12783-0.05243 0.28398-0.11683 0.34702-0.1431 0.18395-0.07666 0.40624-0.16136 0.6413-0.2443l0.07811-0.02755 0.01703 0.0589c0.07483 0.25889 0.5197 1.5654 0.5409 1.5885 0.0032 0.0036 0.0055-0.0045 0.0055-0.01936-6e-5 -0.01401 0.01181-0.28159 0.02638-0.59461l0.02646-0.5691-0.10995-0.21826c-0.04434-0.07365-0.13591-0.19775-0.11787-0.21261 0.01113-0.0092 0.0312 0.0086 0.06046 0.02361 0.12451 0.06232 0.26613 0.11971 0.4406 0.12649 0.19146 0.0074 0.34594-0.05248 0.5078-0.1258 0.03315-0.01552 0.06885-0.04239 0.08231-0.0272 0.01812 0.02045-0.13013 0.20564-0.13235 0.21006l-0.11267 0.22289 0.02739 0.59356c0.01508 0.32645 0.0294 0.59146 0.03184 0.58888 0.01599-0.01692 0.47574-1.369 0.54297-1.5969l0.01456-0.04932 0.21626 0.07905c0.25453 0.09303 0.28093 0.10323 0.51147 0.19747 0.73148 0.29895 0.73962 0.30273 0.81992 0.37937 0.04096 0.03907 0.08785 0.10493 0.10422 0.14639 0.0055 0.0142 0.03057 0.08908 0.05547 0.16638 0.16446 0.51043 0.25889 0.82645 0.27175 0.90934 0.0241 0.15536-0.0457 0.33147-0.17181 0.4335-0.04376 0.03543-0.1233 0.07649-0.18058 0.09331-0.03666 0.01075-0.17296 0.0114-2.5337 0.01242-2.022 8.48e-4 -2.5035-5.27e-4 -2.5402-0.0073zm2.4334-2.6402c-0.29862-0.06501-0.58668-0.26163-0.79654-0.54363-0.11209-0.15067-0.225-0.37323-0.28504-0.56184-0.01421-0.04458-0.01554-0.04642-0.03137-0.04206-0.03018 0.0084-0.08086 0.0035-0.10776-0.01018-0.10224-0.05216-0.17276-0.21814-0.20613-0.48518-0.02038-0.16295-0.0055-0.24513 0.05391-0.29738 0.03767-0.03317 0.0782-0.04491 0.15494-0.04491h0.06085l-0.0045-0.1049c-0.01599-0.3706-0.01442-0.4639 0.0098-0.58868 0.10178-0.52491 0.53522-0.92556 1.0688-0.98796 0.38327-0.04482 0.72523 0.05511 1.0085 0.29478 0.18552 0.15694 0.33501 0.40838 0.39078 0.65732 0.02898 0.12936 0.03334 0.20868 0.02457 0.44844-0.0043 0.1173-0.0078 0.22851-0.0077 0.24713l1.39e-4 0.03389h0.0606c0.09994 0 0.15146 0.02448 0.18631 0.08851 0.03414 0.06273 0.03619 0.15034 0.0077 0.33108-0.04417 0.28011-0.15223 0.44218-0.28186 0.42275-0.01516-0.0023-0.03019-0.0041-0.03339-4e-3 -0.0032 7.9e-5 -0.01653 0.03153-0.02961 0.06989-0.13254 0.38861-0.35985 0.7008-0.65205 0.89544-0.07515 0.05007-0.20249 0.11392-0.28403 0.14247-0.13279 0.04645-0.22116 0.0577-0.30685 0.03905z",
    strokeWidth: 0.0070192
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.96174 1.0398)",
    x: 105.32928,
    y: 12.386542,
    fontFamily: "Jamrul",
    fontSize: "7.4885px",
    strokeDasharray: "0.303777, 0.607555, 0.303777, 1.21511",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.30378,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105.32928,
    y: 12.386542,
    fill: "#0058ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "7.4885px",
    strokeWidth: 0.30378
  }, "Contact"))), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.96174 1.0398)",
    x: 147.5518,
    y: 20.189346,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8455px",
    strokeMiterlimit: 10,
    strokeOpacity: 0.33,
    strokeWidth: 0.066075,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 147.5518,
    y: 20.189346,
    fill: "#0058ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8455px",
    strokeWidth: 0.066075
  }, "Address")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttribute);
export default __webpack_public_path__ + "static/media/attribute.526bc55326d93027235042bc2a0a1776.svg";
export { ForwardRef as ReactComponent };